import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";



@Injectable({
  providedIn: 'root'
})
export class JobsService {
  ApiUrl = "/api/admin/Jobs/"
  constructor(private http: RequestHandlerService) {
  }

  LoadStatistics()
  {
    return this.http.get(this.ApiUrl +'GetStatistics');
  }

  
}